"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var HeartOutline = function HeartOutline(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon icon-no-fill ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12,21.844l-9.588-10c-1.728-1.727-2.156-4.366-1.063-6.551l0,0C2.75,2.491,6.158,1.355,8.96,2.757 c0.545,0.273,1.043,0.631,1.474,1.062L12,5.384l1.566-1.565c2.216-2.215,5.808-2.215,8.023,0c0.431,0.431,0.79,0.929,1.062,1.474 l0,0c1.092,2.184,0.664,4.821-1.062,6.548L12,21.844z",
    stroke: fill,
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
HeartOutline.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
HeartOutline.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = HeartOutline;